
export const Ticket = props => {
  return (
    (<svg
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      className={props.className}
      data-palette="Ticket">
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="Trading_Trade-resources"
          transform="translate(-1189.000000, -55.000000)">
          <g id="Group-5" transform="translate(1176.000000, 25.000000)">
            <g id="Group-6" transform="translate(12.000000, 29.000000)">
              <g id="Group" transform="translate(1.000000, 1.000000)">
                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                <path
                  d="M21,6.757 L19,8.757 L19,4 L10,4 L10,9 L5,9 L5,20 L19,20 L19,17.243 L21,15.243 L21,21.008 C20.9994481,21.5560282 20.5550285,22 20.007,22 L3.993,22 C3.72778147,21.99815 3.47416127,21.8910147 3.28793625,21.7021642 C3.10171122,21.5133136 2.99813697,21.2582184 2.9999753,20.993 L2.9999753,8 L9.003,2 L19.998,2 C20.55,2 21,2.455 21,2.992 L21,6.757 Z M21.778,8.807 L23.192,10.222 L15.414,18 L13.998,17.998 L14,16.586 L21.778,8.808 L21.778,8.807 Z"
                  id="Shape"
                  fill="var(--main-text-primary)"
                  fillRule="nonzero"></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const Support = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      className={props.className}
      data-palette="Support">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L24 0 24 24 0 24z"
                  transform="translate(-1189 -99) translate(1176 25) translate(12 73) translate(1 1)"
                />
                <path
                  fill="var(--main-text-primary)"
                  fillRule="nonzero"
                  d="M12 4c-4.418 0-8 3.582-8 8h3c1.105 0 2 .895 2 2v5c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2v-7C2 6.477 6.477 2 12 2s10 4.477 10 10v7c0 1.105-.895 2-2 2h-3c-1.105 0-2-.895-2-2v-5c0-1.105.895-2 2-2h3c0-4.418-3.582-8-8-8zM4 14v5h3v-5H4zm13 0v5h3v-5h-3z"
                  transform="translate(-1189 -99) translate(1176 25) translate(12 73) translate(1 1)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const TelegramHelp = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 20 17"
      className={props.className}
      data-palette="TelegramHelp">
      <g fill="none" fillRule="evenodd">
        <g fill="var(--main-text-secondary)" fillRule="nonzero">
          <g>
            <g>
              <g>
                <path
                  d="M.931 6.8L18.668.082c.823-.292 1.542.197 1.275 1.42l.002-.001-3.02 13.975c-.224.991-.823 1.232-1.662.765l-4.599-3.33-2.218 2.1c-.245.24-.452.444-.927.444l.326-4.597 8.524-7.564c.37-.32-.083-.501-.572-.182L5.263 9.626.723 8.235C-.263 7.928-.284 7.266.93 6.8z"
                  transform="translate(-1191 -143) translate(1176 25) translate(12 113) translate(3 5)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const DocsIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      className={props.className}
      data-palette="DocsIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L24 0 24 24 0 24z"
                  transform="translate(-1189 -217) translate(1176 25) translate(12 191) translate(1 1)"
                />
                <path
                  fill="var(--main-text-primary)"
                  fillRule="nonzero"
                  d="M5 8h14V5H5v3zm9 11v-9H5v9h9zm2 0h3v-9h-3v9zM4 3h16c.552 0 1 .448 1 1v16c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1z"
                  transform="translate(-1189 -217) translate(1176 25) translate(12 191) translate(1 1)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const CoinIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      className={props.className}
      data-palette="CoinIcon">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L24 0 24 24 0 24z"
                  transform="translate(-1189 -261) translate(1176 25) translate(11 235) translate(2 1)"
                />
                <path
                  fill="var(--main-text-primary)"
                  fillRule="nonzero"
                  d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zm-3.5-6H14c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-4c-1.38 0-2.5-1.12-2.5-2.5S8.62 8 10 8h1V6h2v2h2.5v2H10c-.276 0-.5.224-.5.5s.224.5.5.5h4c1.38 0 2.5 1.12 2.5 2.5S15.38 16 14 16h-1v2h-2v-2H8.5v-2z"
                  transform="translate(-1189 -261) translate(1176 25) translate(11 235) translate(2 1)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const HandShakeIcon = props => {
  return (
    (<svg
      className={props.className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-palette="HandShakeIcon">
      <g>
        <path
          d="M11.7902 10C10.3777 9.99755 7.50003 10 6.26134 11.3886C5.68899 11.9172 5.2632 12.578 5.02355 13.3097C4.78391 14.0414 4.73817 14.8202 4.89059 15.5737C4.87365 15.5883 4.85702 15.6032 4.84071 15.6184L4.06355 16.3467C3.91322 16.4855 3.7935 16.6526 3.71168 16.8379C3.62987 17.0232 3.58768 17.2228 3.58768 17.4245C3.58768 17.6262 3.62987 17.8258 3.71168 18.0111C3.7935 18.1964 3.91322 18.3635 4.06355 18.5023C4.46061 18.8752 5.0113 19.015 5.52309 18.9218C5.58594 19.2024 5.73259 19.4695 5.96504 19.687C6.27132 19.9744 6.66937 20.123 7.07042 20.1337C7.08139 20.5095 7.24002 20.8823 7.54629 21.1698C7.85256 21.4572 8.25162 21.6067 8.65267 21.6164C8.66264 21.9922 8.82226 22.3661 9.12854 22.6535C9.42175 22.9243 9.80584 23.0826 10.2097 23.099C10.6136 23.1155 11.0099 22.9889 11.3253 22.7428L11.7613 23.1507C12.3998 23.7498 13.4353 23.7498 14.0738 23.1507C14.3791 22.8652 14.5377 22.4942 14.5517 22.1194C14.9507 22.1078 15.3448 21.9592 15.6491 21.6737C15.9543 21.3873 16.113 21.0163 16.1249 20.6415C16.5304 20.6277 16.9164 20.469 17.2094 20.1958C17.4518 19.9696 17.6014 19.6889 17.6593 19.3957C17.9161 19.4395 18.1799 19.424 18.4294 19.3505C18.6789 19.277 18.9072 19.1474 19.0959 18.9723C19.2464 18.8335 19.3662 18.6663 19.4481 18.4809C19.5301 18.2955 19.5723 18.0958 19.5723 17.894C19.5723 17.6922 19.5301 17.4925 19.4481 17.3071C19.3662 17.1217 19.2464 16.9545 19.0959 16.8157L18.3776 16.1427L18.5242 15.6087C18.8209 14.5168 18.6707 13.3555 18.1052 12.3693C17.2712 10.9069 15.6531 10.0039 13.9032 10.0039H12.6761C12.6233 10.0013 12.5704 10 12.5175 10H11.7902ZM14.2374 13.6083L16.6367 15.8582L16.6397 15.8602L18.3766 17.4896C18.433 17.5416 18.478 17.6043 18.5087 17.6739C18.5394 17.7434 18.5552 17.8183 18.5552 17.894C18.5552 17.9697 18.5394 18.0446 18.5087 18.1141C18.478 18.1836 18.433 18.2463 18.3766 18.2984C18.26 18.4058 18.1056 18.4657 17.9451 18.4657C17.7846 18.4657 17.6302 18.4058 17.5136 18.2984L16.1958 17.0633C16.0992 16.9731 15.9705 16.9227 15.8366 16.9227C15.7028 16.9227 15.5741 16.9731 15.4775 17.0633L15.4635 17.0749C15.4165 17.1183 15.379 17.1705 15.3534 17.2285C15.3278 17.2864 15.3146 17.3488 15.3146 17.4119C15.3146 17.4749 15.3278 17.5373 15.3534 17.5953C15.379 17.6532 15.4165 17.7054 15.4635 17.7488L16.4911 18.7121C16.7305 18.9354 16.7305 19.2986 16.4911 19.5229C16.3851 19.6206 16.2475 19.6794 16.1019 19.6891C15.9562 19.6989 15.8117 19.659 15.693 19.5763C15.5939 19.5066 15.4729 19.4729 15.351 19.4811C15.229 19.4893 15.1139 19.5388 15.0255 19.621C14.9392 19.7013 14.8871 19.8103 14.8795 19.9263C14.8719 20.0424 14.9095 20.1569 14.9846 20.2473C15.0742 20.3565 15.1184 20.4944 15.1084 20.6338C15.0984 20.7731 15.035 20.9038 14.9308 20.9998C14.8233 21.099 14.6833 21.1581 14.5355 21.1666C14.3876 21.1751 14.2414 21.1326 14.1227 21.0464C14.0241 20.9745 13.9026 20.9387 13.7796 20.9454C13.6565 20.9522 13.5399 21.001 13.4503 21.0833C13.3628 21.1636 13.3098 21.273 13.3018 21.3897C13.2939 21.5065 13.3316 21.6218 13.4074 21.7126C13.499 21.8232 13.5445 21.9634 13.5347 22.1052C13.5249 22.247 13.4606 22.38 13.3545 22.4777C13.2364 22.5868 13.0798 22.6476 12.917 22.6476C12.7543 22.6476 12.5977 22.5868 12.4796 22.4777L12.0476 22.0728L12.2052 21.9252C12.3557 21.7864 12.4756 21.6192 12.5575 21.4338C12.6394 21.2484 12.6816 21.0487 12.6816 20.8469C12.6816 20.6451 12.6394 20.4454 12.5575 20.26C12.4756 20.0746 12.3557 19.9074 12.2052 19.7686C11.9071 19.4904 11.5127 19.3311 11.0999 19.3219C11.0877 18.9287 10.9167 18.556 10.624 18.2848C10.3254 18.0068 9.93069 17.8478 9.51761 17.8391C9.5055 17.4459 9.3345 17.0733 9.04174 16.8021C8.85008 16.6245 8.61773 16.4939 8.36393 16.4212C8.11012 16.3484 7.84215 16.3355 7.58221 16.3836C7.51644 16.0914 7.36256 15.8249 7.14025 15.6184C6.96984 15.4601 6.76677 15.3389 6.54454 15.2629C6.3223 15.1869 6.08599 15.1578 5.85131 15.1775C5.77272 14.6085 5.83392 14.0295 6.02989 13.488C6.22586 12.9465 6.55101 12.4579 6.97864 12.0625C7.41075 11.6606 7.92884 11.3568 8.49578 11.1729C9.10969 10.9982 9.66446 10.9292 10.2579 10.9982L8.8063 12.0372C8.62058 12.1686 8.46413 12.3352 8.34641 12.527C8.22868 12.7189 8.15213 12.9319 8.12136 13.1534C8.09059 13.3748 8.10625 13.6 8.16739 13.8154C8.22853 14.0308 8.33388 14.2319 8.47708 14.4065C8.7667 14.76 9.18517 14.9911 9.64544 15.0519C10.1057 15.1127 10.5723 14.9984 10.9482 14.7328L12.5205 13.6093H14.2364L14.2374 13.6083ZM9.3969 12.8189L11.9828 10.971H12.5175C12.5664 10.9708 12.6153 10.9721 12.6641 10.9749H13.9032C15.3039 10.9749 16.5819 11.6983 17.2333 12.8412C17.6743 13.6142 17.79 14.5124 17.5595 15.3601L17.5565 15.3698L14.8031 12.7801C14.7098 12.6889 14.5831 12.6376 14.4509 12.6373H12.3559C12.25 12.6375 12.1469 12.6705 12.0616 12.7315L10.3576 13.9492C10.1902 14.0658 9.9834 14.1158 9.77941 14.0889C9.57541 14.062 9.38968 13.9603 9.26022 13.8045C9.19989 13.7322 9.15542 13.6486 9.12953 13.5589C9.10364 13.4692 9.09689 13.3753 9.10969 13.2829C9.1225 13.1906 9.15458 13.1018 9.20398 13.022C9.25337 12.9422 9.31903 12.8731 9.3969 12.8189ZM9.83785 21.1795L9.84783 21.1698L10.624 20.4415L10.633 20.4337C10.7502 20.33 10.9033 20.2733 11.0617 20.2749C11.2201 20.2765 11.372 20.3364 11.4869 20.4425C11.5434 20.4945 11.5883 20.5572 11.619 20.6268C11.6497 20.6963 11.6655 20.7712 11.6655 20.8469C11.6655 20.9226 11.6497 20.9975 11.619 21.067C11.5883 21.1365 11.5434 21.1992 11.4869 21.2513L10.7098 21.9796C10.5932 22.087 10.4388 22.1469 10.2783 22.1469C10.1178 22.1469 9.96338 22.087 9.84683 21.9796C9.79115 21.9283 9.74662 21.8666 9.71589 21.7983C9.68515 21.7299 9.66883 21.6562 9.6679 21.5816C9.66697 21.507 9.68145 21.4329 9.71047 21.3638C9.73949 21.2948 9.78347 21.2321 9.83785 21.1795ZM9.91467 19.7598L9.9047 19.7686L9.12854 20.4968L9.11856 20.5056C9.0013 20.6089 8.84827 20.6653 8.69012 20.6635C8.53196 20.6617 8.38033 20.6018 8.26558 20.4959C8.20979 20.4443 8.16524 20.3824 8.13458 20.3137C8.10392 20.2451 8.08778 20.1711 8.08713 20.0963C8.08648 20.0214 8.10132 19.9472 8.13078 19.878C8.16024 19.8089 8.20371 19.7462 8.2586 19.6938L8.26558 19.687L9.04174 18.9587L9.04873 18.9519C9.16578 18.8474 9.31922 18.7899 9.47809 18.7912C9.63695 18.7925 9.7894 18.8523 9.9047 18.9587C9.96053 19.01 10.0052 19.0718 10.036 19.1402C10.0668 19.2087 10.0832 19.2825 10.0841 19.3572C10.0851 19.432 10.0705 19.5061 10.0414 19.5753C10.0123 19.6444 9.96921 19.7072 9.91467 19.7598ZM8.32345 18.2848L7.54629 19.0131L7.53931 19.0199C7.42225 19.1244 7.26881 19.1819 7.10995 19.1806C6.95109 19.1793 6.79863 19.1195 6.68334 19.0131C6.62692 18.961 6.58198 18.8983 6.55128 18.8288C6.52057 18.7592 6.50473 18.6843 6.50473 18.6087C6.50473 18.533 6.52057 18.4581 6.55128 18.3886C6.58198 18.319 6.62692 18.2563 6.68334 18.2042L7.4595 17.476C7.5761 17.3682 7.73072 17.3082 7.89147 17.3082C8.05222 17.3082 8.20685 17.3682 8.32345 17.476C8.37939 17.5275 8.42408 17.5895 8.45483 17.6582C8.48558 17.727 8.50177 17.8011 8.50242 17.876C8.50307 17.951 8.48817 18.0253 8.45862 18.0946C8.42907 18.1638 8.38547 18.2265 8.33043 18.279L8.32345 18.2848ZM6.42196 17.1011L5.6458 17.8294C5.52931 17.9373 5.37465 17.9975 5.21382 17.9975C5.053 17.9975 4.89833 17.9373 4.78185 17.8294C4.72527 17.7773 4.6802 17.7145 4.6494 17.6449C4.6186 17.5753 4.60272 17.5003 4.60272 17.4245C4.60272 17.3487 4.6186 17.2737 4.6494 17.2041C4.6802 17.1344 4.72527 17.0717 4.78185 17.0196L5.559 16.2913C5.67555 16.1839 5.82997 16.124 5.99048 16.124C6.151 16.124 6.30541 16.1839 6.42196 16.2913C6.47853 16.3434 6.5236 16.4062 6.5544 16.4758C6.5852 16.5454 6.60109 16.6204 6.60109 16.6962C6.60109 16.772 6.5852 16.847 6.5544 16.9167C6.5236 16.9863 6.47853 17.0491 6.42196 17.1011Z"
          fill="var(--main-text-primary)"
        />
        <path
          d="M12 0.4C9.79107 0.4 8 2.19107 8 4.4C8 6.60893 9.79107 8.4 12 8.4C14.2089 8.4 16 6.60893 16 4.4C16 2.19107 14.2089 0.4 12 0.4ZM12 7.72143C10.1661 7.72143 8.67857 6.23393 8.67857 4.4C8.67857 2.56607 10.1661 1.07857 12 1.07857C13.8339 1.07857 15.3214 2.56607 15.3214 4.4C15.3214 6.23393 13.8339 7.72143 12 7.72143ZM12.4259 4.19286L12.1991 4.14018V2.94107C12.5384 2.9875 12.7482 3.2 12.7839 3.46071C12.7884 3.49643 12.8188 3.52232 12.8545 3.52232H13.2554C13.2973 3.52232 13.3304 3.48571 13.3268 3.44375C13.2723 2.8875 12.8143 2.53036 12.2027 2.46875V2.17679C12.2027 2.1375 12.1705 2.10536 12.1313 2.10536H11.8804C11.8411 2.10536 11.8089 2.1375 11.8089 2.17679V2.47143C11.1768 2.53304 10.6821 2.88214 10.6821 3.53393C10.6821 4.1375 11.1268 4.42857 11.5938 4.54018L11.8143 4.59643V5.87054C11.4196 5.81786 11.1982 5.60714 11.1527 5.32321C11.1473 5.28929 11.117 5.26429 11.0821 5.26429H10.6696C10.6277 5.26429 10.5946 5.3 10.5982 5.34196C10.6384 5.83304 11.0107 6.28482 11.8054 6.34286V6.62321C11.8054 6.6625 11.8375 6.69464 11.8768 6.69464H12.1304C12.1696 6.69464 12.2018 6.6625 12.2018 6.62232L12.2 6.33929C12.8991 6.27768 13.3991 5.90357 13.3991 5.23214C13.3982 4.6125 13.0045 4.33571 12.4259 4.19286ZM11.8134 4.04821C11.7634 4.03393 11.7214 4.02054 11.6795 4.00357C11.3777 3.89464 11.2375 3.71875 11.2375 3.49196C11.2375 3.16786 11.483 2.98304 11.8134 2.94107V4.04821ZM12.1991 5.87321V4.67946C12.2268 4.6875 12.2518 4.69375 12.2777 4.69911C12.7 4.82768 12.842 5.00625 12.842 5.28036C12.842 5.62946 12.5795 5.83929 12.1991 5.87321Z"
          fill="var(--main-text-primary)"
        />
      </g>
    </svg>)
  );
};

export const BookMark = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      className={props.className}
      data-palette="BookMark">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L24 0 24 24 0 24z"
                  transform="translate(-1189 -306) translate(1176 25) translate(12 279) translate(1 2)"
                />
                <path
                  fill="var(--main-text-primary)"
                  fillRule="nonzero"
                  d="M3 18.5V5c0-1.657 1.343-3 3-3h14c.552 0 1 .448 1 1v18c0 .552-.448 1-1 1H6.5C4.567 22 3 20.433 3 18.5zM19 20v-3H6.5c-.828 0-1.5.672-1.5 1.5S5.672 20 6.5 20H19zM10 4H6c-.552 0-1 .448-1 1v10.337c.469-.223.981-.338 1.5-.337H19V4h-2v8l-3.5-2-3.5 2V4z"
                  transform="translate(-1189 -306) translate(1176 25) translate(12 279) translate(1 2)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const Folder = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      className={props.className}
      data-palette="Folder">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L24 0 24 24 0 24z"
                  transform="translate(-1189 -350) translate(1176 25) translate(12 324) translate(1 1)"
                />
                <path
                  fill="var(--main-text-primary)"
                  fillRule="nonzero"
                  d="M12.414 5H21c.552 0 1 .448 1 1v14c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h7.414l2 2zM8 19h12v-8H8v8zm-2 0v-9c0-.552.448-1 1-1h13V7h-8.414l-2-2H4v14h2z"
                  transform="translate(-1189 -350) translate(1176 25) translate(12 324) translate(1 1)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const Graph = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      className={props.className}
      data-palette="Graph">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0L24 0 24 24 0 24z"
                  transform="translate(-1188 -393) translate(1176 25) translate(12 367) translate(0 1)"
                />
                <path
                  fill="var(--main-text-primary)"
                  fillRule="nonzero"
                  d="M11 .543c.33-.029.663-.043 1-.043C18.351.5 23.5 5.649 23.5 12c0 .337-.014.67-.043 1h-1.506c-.502 5.053-4.766 9-9.951 9-5.523 0-10-4.477-10-10 0-5.185 3.947-9.449 9-9.95V.542v.001zM11 13V4.062c-4.187.533-7.24 4.226-6.975 8.438C4.289 16.712 7.78 19.995 12 20c4.032 0 7.434-3 7.938-7H11zm10.448-2C20.976 6.545 17.455 3.024 13 2.552V11h8.448z"
                  transform="translate(-1188 -393) translate(1176 25) translate(12 367) translate(0 1)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const Blog = props => {
  return (
    (<svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      {...props}
      data-palette="Blog">
      <title>Group</title>
      <g
        id="Mobile"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="M5-New-header-mobile-inside-Copy-13"
          transform="translate(-13.000000, -547.000000)">
          <g id="Group-10" transform="translate(0.000000, 138.000000)">
            <g id="Group" transform="translate(13.000000, 409.000000)">
              <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
              <path
                d="M2,3.993 C2.00380782,3.44655554 2.44555966,3.00435839 2.992,3 L21.008,3 C21.556,3 22,3.445 22,3.993 L22,20.007 C21.9961922,20.5534445 21.5544403,20.9956416 21.008,21 L2.992,21 C2.44397181,20.9994481 2,20.5550285 2,20.007 L2,3.993 Z M11,5 L4,5 L4,19 L11,19 L11,5 Z M13,5 L13,19 L20,19 L20,5 L13,5 Z M14,7 L19,7 L19,9 L14,9 L14,7 Z M14,10 L19,10 L19,12 L14,12 L14,10 Z"
                id="Shape"
                stroke="#19232D"
                strokeWidth="0.6"
                fill="var(--main-text-primary)"
                fillRule="nonzero"></path>
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export const InsuranceFundIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
      data-palette="InsuranceFundIcon">
      <path
        stroke="var(--main-text-primary)"
        fill="transparent"
        strokeWidth="2"
        d="M11.648 2.105a.642.642 0 01.704 0 19.293 19.293 0 007.992 3.026c.151.021.29.096.39.21a.62.62 0 01.155.409v5.624c0 4.864-2.93 8.413-8.66 10.584a.644.644 0 01-.458 0c-5.73-2.171-8.66-5.721-8.66-10.583V5.75a.62.62 0 01.156-.41.638.638 0 01.39-.21 19.293 19.293 0 007.991-3.025v0z"></path>
      <path
        fill="var(--main-text-primary)"
        d="M15 13.468c0 .589-.198 1.1-.595 1.532-.39.425-.959.699-1.706.82V17h-1.19v-1.138a6.006 6.006 0 01-1.408-.266A4.037 4.037 0 019 15.053l.645-1.553c.31.22.67.397 1.08.532.41.135.814.202 1.21.202.754 0 1.131-.202 1.131-.606 0-.213-.109-.37-.327-.468-.212-.107-.556-.217-1.032-.33a9.957 9.957 0 01-1.309-.383 2.25 2.25 0 01-.902-.67c-.251-.305-.377-.717-.377-1.234 0-.61.205-1.132.615-1.564.41-.44 1.002-.71 1.775-.809V7h1.19v1.149a5.34 5.34 0 011.081.213c.35.106.661.244.932.415l-.605 1.563c-.66-.383-1.302-.574-1.923-.574-.39 0-.675.064-.853.191a.553.553 0 00-.268.48c0 .198.106.347.317.446.212.1.552.202 1.022.309.529.12.965.251 1.309.393.35.135.651.355.902.66.258.298.387.705.387 1.223z"></path>
    </svg>)
  );
};

export const ClearCache = props => {
  return (
    (<svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      data-palette="ClearCache">
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        d="M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm1 2H6v12h12V8zm-9 3h2v6H9v-6zm4 0h2v6h-2v-6zM9 4v2h6V4H9z"
        fill="var(--dropdownIconColor)"
      />
    </svg>)
  );
};

export const SwitchAccount = props => {
  return (
    (<svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      data-palette="SwitchAccount">
      <path
        fill="var(--brand-bg-primary)"
        d="M8 15.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM8 14A6 6 0 108 2a6 6 0 000 12zM4.25 8.75H11v1.5H8v2.25L4.25 8.75zm3.75-3V3.5l3.75 3.75H5v-1.5h3z"></path>
    </svg>)
  );
};

export const SubAccount = props => {
  return (
    (<svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="18"
      fill="none"
      viewBox="0 0 15 18"
      data-palette="SubAccount">
      <path
        fill="var(--main-text-primary)"
        d="M6 10.5V12a4.5 4.5 0 00-4.5 4.5H0a6 6 0 016-6zm0-.75a4.499 4.499 0 01-4.5-4.5C1.5 2.764 3.514.75 6 .75s4.5 2.014 4.5 4.5-2.014 4.5-4.5 4.5zm0-1.5a3 3 0 100-6 3 3 0 100 6zm4.5 7.875l-2.204 1.159.42-2.454-1.782-1.739 2.464-.358L10.5 10.5l1.102 2.233 2.464.358-1.783 1.739.42 2.454-2.203-1.159z"></path>
    </svg>)
  );
};
export const GroupUsers = props => {
  return (
    (<svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
      data-palette="GroupUsers">
      <path
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        d="M15.583 19.25v-1.833a3.667 3.667 0 00-3.666-3.667H4.583a3.667 3.667 0 00-3.666 3.667v1.833M8.25 10.083a3.667 3.667 0 100-7.333 3.667 3.667 0 000 7.333zM21.083 19.25v-1.833a3.666 3.666 0 00-2.75-3.548M14.667 2.87a3.667 3.667 0 010 7.103"></path>
    </svg>)
  );
};
export const PortfolioMargin = props => {
  return (
    (<svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      data-palette="PortfolioMargin">
      <path
        fill="var(--main-text-primary)"
        d="M4.25 3.75V1.5A.75.75 0 015 .75h6a.75.75 0 01.75.75v2.25h3a.75.75 0 01.75.75V15a.75.75 0 01-.75.75H1.25A.75.75 0 01.5 15V4.5a.75.75 0 01.75-.75h3zM2 12v2.25h12V12H2zm0-1.5h12V5.25H2v5.25zm3.75-8.25v1.5h4.5v-1.5h-4.5zm1.5 6h1.5v1.5h-1.5v-1.5z"></path>
    </svg>)
  );
};
export const GvolIcon = props => {
  return (
    (<svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
      data-palette="GvolIcon">
      <path
        stroke="var(--main-text-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20 4H4a1 1 0 00-1 1v10a1 1 0 001 1h16a1 1 0 001-1V5a1 1 0 00-1-1zM7 20h10M9 16v4M15 16v4"></path>
      <path
        stroke="var(--main-text-primary)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8 12l3-3 2 2 3-3"></path>
    </svg>)
  );
};
